module.exports = __webpack_public_path__ + "img/logo.f12a9fb8.jpg";